import {Component, Input} from '@angular/core';
import {Section} from "../../../../../framework/model/core/sections/section";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {OrderService} from "../../../../services/OrderService";
import {AppSettings} from "../../../../conf/appSettings";
import {Panel} from "../../../../../framework/model/core/panel/panel";
import {AppDataService} from "../../../../services/AppDataService";

@Component({
    selector: 'app-sections-grid',
    templateUrl: './sections-grid.component.html',
    styleUrls: ['./sections-grid.component.css']
})
export class SectionsGridComponent {

    @Input()
    public models: Array<Section>;

    @Input()
    public settings;

    @Input()
    public options = {};

    @Input()
    public panel:Panel;

    public filters = {'includeInMenu': true, 'allimages':true, 'limit':40};

    public listModels = false;

    constructor(public tools: ModelToolsProvider, public appDataService:AppDataService,
                public orderService: OrderService, public appSettings: AppSettings) {}
    ngOnInit(){
        this.settings = this.settings ? this.settings : this.appSettings.getSettings('store');

        this.options['mode'] = this.options['mode'] || this.settings['subsections_mode'] || 'list'
        if(this.options['filters']){
            this.filters = this.options['filters']
        }

        if(this.panel && this.panel.data.section){
            this.models = this.appDataService.getSectionSubSections(this.panel.data.section);
        }
        else{
            this.filters['topsec'] = true;
        }

        if(!this.models){
            this.models = []
            this.listModels = true
        }

        if (!this.settings['section_style_image']) {
            this.settings['section_style_image'] = {'height': '100%', 'background-size': 'cover'}
        }
        if (!this.settings['section_style_card']) {
            this.settings['section_style_card'] = {'aspect-ratio': '1/1'}
        }

        if (!this.settings['section_size']) {
            this.settings['section_size'] = '12';
            this.settings['section_sizeMd'] = '4';
            this.settings['section_sizeSm'] = '6';
            this.settings['section_sizeXs'] = '6';
            this.settings['section_sizeLg'] = '3';
        }
    }

}
